/**
 * NicLen.Backend API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type AssignmentCompletionOption = 'Good' | 'Absent' | 'Incomplete' | 'Defect' | 'GeneralProblem';

export const AssignmentCompletionOption = {
    Good: 'Good' as AssignmentCompletionOption,
    Absent: 'Absent' as AssignmentCompletionOption,
    Incomplete: 'Incomplete' as AssignmentCompletionOption,
    Defect: 'Defect' as AssignmentCompletionOption,
    GeneralProblem: 'GeneralProblem' as AssignmentCompletionOption
};

